export default __webpack_public_path__ + "static/media/BPLLogo.28fd999d.png";